import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoanPurposePage.css';

function LoanPurposePage({ data, updateData }) {
  const [purpose, setPurpose] = useState(data.purpose || '');
  const navigate = useNavigate();

  const purposeOptions = [
    { value: 'business', label: 'Business' },
    { value: 'personal', label: 'Personal' },
    { value: 'emergency', label: 'Emergency' },
    { value: 'education', label: 'Education & Training' }
  ];

  const handleContinue = () => {
    if (!purpose) {
      alert('Please select purpose of loan');
      return;
    }
    updateData('purpose', purpose);
    navigate('/personal-details');
  };

  return (
    <div className="loan-purpose-page">
      <div className="container">
        <div className="page-header">
          <h2>Purpose of Loan</h2>
          <p>Select the main purpose for your loan</p>
        </div>

        <div className="purpose-options">
          {purposeOptions.map((option) => (
            <div 
              key={option.value}
              className={`purpose-option ${purpose === option.value ? 'selected' : ''}`}
              onClick={() => setPurpose(option.value)}
            >
              <div className="purpose-icon">
                {option.value === 'business' ? '💼' :
                 option.value === 'personal' ? '🏠' :
                 option.value === 'emergency' ? '🚨' : '🎓'}
              </div>
              <span>{option.label}</span>
            </div>
          ))}
        </div>

        <button 
          className="continue-btn"
          onClick={handleContinue}
          disabled={!purpose}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default LoanPurposePage;